import "./statement.scss";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import OrgEntries from "../../../components/organization-entries-list/org-entries";
import { fetchLastestTransactions } from "../../../store/TransactionSlice";
import { fetchLatest } from "../../../store/ReceiptsSlice";

const Statement = () => {

    const dispatch = useAppDispatch();

    useEffect( () => {
        dispatch( fetchLatest('all') )
        dispatch( fetchLatest('invoices') )
        dispatch( fetchLatest('deposits') )
        dispatch( fetchLatest('purchases') )
        dispatch( fetchLatest('payments') )
    }, [dispatch]);

    return (
        <div className="admin-receipt-wrapper">
            
            <h1 className="page-title">
                Extrato da empresa
                <small>
                    Todas as transacoes da sua empresa.
                </small>
            </h1>

            <OrgEntries />
        </div>
    )
}

export default Statement;